import {hasDeclinedConsent} from "../../utility/consent";

export type QuestionPageView = "DECLINED" | "FINISHED" | "CLOSED" | "QUESTION";

export interface ResolveQuestionPageViewArgs {
	/**
	 * The survey stats returned with the next question, if loaded.
	 */
	survey?: {hasUserConsent?: boolean | null} | null;
	isFinished: boolean;
	surveyClosed: boolean;
	isPreview: boolean;
}

/**
 * Decides which top-level view the question page shows. A declined consent always wins:
 * the server still hands out a next question after a decline, so the responder must not
 * advance or finish the survey while the respondent is declined.
 */
export const resolveQuestionPageView = ({
	survey,
	isFinished,
	surveyClosed,
	isPreview,
}: ResolveQuestionPageViewArgs): QuestionPageView => {
	if (!isPreview && hasDeclinedConsent(survey)) return "DECLINED";
	if (isFinished) return "FINISHED";
	if (surveyClosed) return "CLOSED";
	return "QUESTION";
};
